import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import Message from 'src/component/Message'
import { history } from 'src/core/router'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import { shareToLink } from 'src/helper/webviewFun'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.guildStore = this.props.store.register('admin-control/vip')
  }

  state = {
    uid:0,
    lang: langM.ar,
    language: 'en',
    seachValue:'',
    userList:[],
    seachHad:false,
    userId:0,
    days:0,
    level:0,
    uidSend:0,
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })
    setDocumentTitle("Send VIP")
    // console.log(uid, 'uid')

    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async () => {
    let { uid, accesstoken } = await localstorage.get('userInfo')
    this.guildStore.AdminLogin(config.hostAdm, uid, accesstoken, null, (error) => {
      if (error) {
        this.refs.msg.show(error.message)
      }
    })
  }
  findForSeach = async() => {
      this.setState({
      seachHad:false,
      uidSend:0,
     })
     let {seachValue} = this.state

     let res = await http.post('/web/user/info', { uidDuid:seachValue+'' })
     if (res.code == 0) {
       this.setState({
        userList:res.res || {},
        seachHad:true,
        uidSend:parseInt(res.res?res.res.uid : 0),
       })
      }else{
        this.setState({
          userList:{},
          seachHad:true,
          uidSend:0,
         })
       }
  }

  setId = (uid) => {
    this.setState({uidSend:parseInt(uid)})
  }

  setUserId = (e) => {
    console.log(e.target.value)
    this.setState({seachValue:e.target.value})
  }

  setDays = (e) => {
    console.log(e.target.value)
    let days = parseInt(e.target.value)
    if (days>30) {
      this.setState({days:0})
      this.refs.msg.show(this.state.lang.limit30 || "")
      return
    }
    this.setState({days:days})
  }

  selectLevel = (e) => {
    let level = parseInt(e.target.value)
    if (level>4) {
      level=0
    }
    this.setState({ level: level })
  }

  SendVipBtn = async () => {
    console.log(this.state)
    // this.setState({ desc: "test" })
    if (this.state.uidSend==0) {
      this.refs.msg.show(this.state.lang.PleaseSelectUserId || "")
      return
    }

    if (this.state.days==0) {
      this.refs.msg.show(this.state.lang.PleaseEnterDays || "")
      return
    }

    if (this.state.level==0) {
      this.refs.msg.show(this.state.lang.PleaseSelectVIP || "")
      return
    }

    
    // this.setState({
    //   uid,accesstoken
    // })

    if (this.state.days>30) {
      this.refs.msg.show(this.state.lang.limit30 || "")
      return
    }

    if (this.state.level>4) {
      return
    }

        let map = {
          "days": this.state.days,
          "duids": [
            this.state.uidSend+''
          ],
          "noble_id": this.state.level,
          "reason": "send by manager"
        }
    
    // let {uid, accesstoken} = this.state
    let msg = await this.guildStore.PresentNoble(config.hostAdm, map, (msg)=>{
      console.log(msg)
      if (msg!="success") {
        this.refs.msg.show(msg || "")
      } else {
        this.refs.msg.show(this.state.lang.success)
        // this.guildStore.PresentNoble(map)
      }
      // 开始放送
    })


  }

  render() {
    let { lang , seachValue , userList , seachHad } = this.state
    return (
      <div className='admin-control-panel'>   
        <div className='nav'>
          <li onClick={e => history.push(`/admin-control/agency_create`)}>Create Agency</li>
          <li className='current' onClick={e => history.push(`/admin-control/guild`)}>Send VIP</li>
        </div>     
        <div className='title'>{lang.sendVip}</div>
        {/* 步骤1 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>{lang.InputId}</div>
          <div className="find-hanlde-view">
            <input className="input-root" type="number" onChange={e => this.setUserId(e)} placeholder={lang.enterID}></input>
            <div className="find-line"></div>
            <div className={`find-btn ${seachValue.length > 0 ? 'havevalue' : ''}`} onClick={this.findForSeach}>{lang.find}</div>
          </div>
          {userList && userList.uid>0 && <div className='user-root'>
             <div className='user-title'>{lang.userText}</div>
             <div className="application-user-info">
                <div className="avatar-root">
                  <img className="avatar-img" src={userList.avatarurl}></img>
                  {userList.gender == 1 && <img className="img-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
                  {userList.gender == 2 && <img className="img-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
                </div>
                <div className="user-info">
                  <div className="user-info-top">
                    <div className="top-text">{userList.nickname}</div>
                    
                  </div>
                  <div className="user-info-buttom">ID: {userList.duid}</div>
                </div>
 
              </div>
            </div>}
          
            {seachHad && userList.length == 0 && <div className='not-found'>{lang.notFound}</div>}
        </div>

        {/* 步骤2 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>{lang.InputDaysDes}</div>
          <div className="find-hanlde-view">
            <input className="input-root" type="number" onChange={e => this.setDays(e)} placeholder={lang.InputDays} ref="vipday"></input>
          </div>                  
        </div>

        {/* 步骤3 */}
        <div className='body-root-admin-control-panel'>
          <div className='title-name'>{lang.SelectDay}</div>
          <div className="select-ban">
          <div className="time-select">
            <fieldset onChange={(e) => this.selectLevel(e)} className="two">
              <div>
                <input type="radio" id="hour" name="two" value="1" />
                <label for="hour" htmlFor="radio">
                  VIP 1
                </label>
              </div>
              <div>
                <input type="radio" id="hours" name="two" value="2" />
                <label for="hours" htmlFor="radio">
                VIP 2
                </label>
              </div>
              <div>
                <input type="radio" id="day" name="two" value="3" />
                <label for="day" htmlFor="radio">
                VIP 3
                </label>
              </div>
              <div>
                <input type="radio" id="days" name="two" value="4" />
                <label for="days" htmlFor="radio">
                VIP 4
                </label>
              </div>              
            </fieldset>
          </div>
        </div>
          
          
        </div>
        <Message ref="msg"/>
        {
          this.guildStore.data.adminInfo.token &&
          this.guildStore.data.adminInfo.token.length > 0 && (
            <div className='web-link' onClick={e => this.SendVipBtn()}>{lang.send}</div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/guild/index.js